import { getRelateTeamInfo, getAssignTeamInfo, getFollowUsers } from '@/services/index'
import { getRecycleRuleTips, getRecycleLogTip } from '@/services/confingAutoWithdraw'

const state = {
  relateTeamInfo: [], // 信息来源关联
  assignTeamInfo: [], // 信息分配关联
  isInfoSign: 0, // 选择备案的方式，0:备案作为信息类型的option之一；1:备案-信息类型标记字段，在接口的info 模块返回 isInfoSign
  recycleRuleTips: '', // 回收规则提示
  recycleLogTips: '', // 回收规则保存后提示
  isInvalid: false, // 是否展示无效信息
  isDiscard: false // 是否展示丢单信息
}
const getters = {}

const mutations = {
  SET_RELATE_LIST_DATA (state, data) {
    state.relateTeamInfo = data
  },
  SET_ASSIGN_LIST_DATA (state, data) {
    state.assignTeamInfo = data
  },
  SET_IS_INFO_SIGN (state, data) {
    state.isInfoSign = data
  },
  SET_RECYCLE_TIPS (state, data = '') {
    state.recycleRuleTips = data
  },
  SET_RECYCLE_LOG_TIPS (state, data = '') {
    state.recycleLogTips = data
  },
  /**
   * Boolean
   * 存放是否选择了丢单
   */
  UPDATE_IS_INVALID (state, data) {
    state.isInvalid = data
  },
  /**
   * Boolean
   * 存放是否选择了无效
   */
  UPDATE_IS_DISCARD (state, data) {
    state.isDiscard = data
  }
}

const actions = {
  async fetchRelateTeamInfo ({ state, commit }) {
    const chain = await getRelateTeamInfo().onSuccess(async payload => {
      commit('SET_RELATE_LIST_DATA', payload)
    })
    return chain
  },
  async fetchAssignTeamInfo ({ state, commit }) {
    const chain = await getAssignTeamInfo().onSuccess(async payload => {
      commit('SET_ASSIGN_LIST_DATA', payload)
    })
    return chain
  },
  async fetchFollowUsers ({ state, commit }) {
    const chain = await getFollowUsers().onSuccess(async payload => {
      commit('SET_ASSIGN_LIST_DATA', payload)
    })
    return chain
  },
  async fetchRecycleRuleTips ({ state, commit }) {
    const chain = await getRecycleRuleTips().onSuccess(async payload => {
      commit('SET_RECYCLE_TIPS', payload)
    })
    return chain
  },
  async fetchRecycleLogTip ({ state, commit }, params) {
    const chain = await getRecycleLogTip()
    chain
      .params(params)
      .onSuccess(async payload => {
        commit('SET_RECYCLE_LOG_TIPS', payload)
      }).fetch()
    return chain
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
